// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__gBALc","select":"Header_select__2NL1W","clinic":"Header_clinic__1aWGK"};